import React, { useEffect, useState } from 'react'
import { DetallesColaboradores, getSession } from "../utils/utils";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faEye, faEyeSlash, faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import axios from 'axios';

import { getOrDeleteRequest, postOrPutRequest } from '../utils/utils';

import DataTableComponent from './DataTableComponent/DataTableComponent';

const CRUDColaboradores = () => {
    const [loading, setLoading] = useState(true);
    const [colaboradores, setColaboradores] = useState([]);
    const [search, setSearch] = useState("");

    const columns = [
		{
			name: '#',
			width: '70px',
			selector: (row) => row.id
		},
		// {
        //     name: '# de Autorización',
        //     width: '180px',
        //     selector: (row) => row.id_autorizacion
        // },
        {
            name: 'Colaborador',
            width: '370px',
            selector: (row) => row.nombre
        },
        {
            name: 'DUI',
            width: '130px',
            selector: (row) => row.dui
        },
        {
            name: 'Área de trabajo',
            width: '190px',
            selector: (row) => row.area_trabajo
        },
		{
            name: 'NIT de la sucursal',
            width: '190px',
            selector: (row) => row.id_empresa
        },
		{
            name: 'Estado',
            width: '120px',
            selector: (row) => {
				return row.status === 1 ? 
					<span className="bg-green-100 text-green-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded-full dark:bg-green-200 dark:text-green-900">
						Activo
					</span>
				: 
					<span className="bg-red-100 text-red-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded-full dark:bg-red-200 dark:text-red-900">
						Inactivo
					</span>
				;
			}
        },
    ];

    const getColaboradores = async (page = 1, items = 10, search = null) => {
        setLoading(true);

        let session = await getSession();
        
        if (!session) {
            setLoading(false);
            setColaboradores([]);
            return;
        }
                        
        let uri = search ? `empresa/colaboradores/${session?.nit}?page=${page}&items=${items}&search=${search}` : `empresa/colaboradores/${session?.nit}?page=${page}&items=${items}`;
        let response = await getOrDeleteRequest(
            uri,
            'GET',
        );
        
        if (response.type === 'success') {
            setColaboradores(response.data);
        } else {
            setColaboradores([]);
        }
        setLoading(false);
    }

    const deleteColaborador = async (id) => {
        Swal.fire({
            title: "¿Estás seguro de borrar este colaborador?",
            text: "¡Esta acción no se puede deshacer!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                let uri = `empresa/colaboradores/destroy/${id}`;

                let result = await postOrPutRequest(
                    uri,
                    'PUT',
                    null,
                    {}
                );

                if (result.type === 'success') {
                    getColaboradores();
                    Swal.fire("¡Eliminado!", "El colaborador ha sido eliminado.", "success");
                }
            }
        });

    };

    const enableOrDisableColaborador = async (id, status) => {
        let action = status === 1 ? 'desactivar' : 'activar';
        Swal.fire({
            title: `¿Estás seguro de ${action} este colaborador?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: `Sí, ${action}`,
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                let uri = `empresa/colaboradores/` + (status === 1 ? 'disable/' : 'enable/') + id;

                let result = await getOrDeleteRequest(
                    uri,
                    'PUT',
                    null,
                    false
                );

                if (result.type === 'success') {
                    getColaboradores();
                    Swal.fire("¡Actualizado!", "El colaborador ha sido actualizado.", "success");
                }
            }
        });
    };

    useEffect(function () {
        if (!loading) return;
        getColaboradores();
    }, []);

    // const eliminarSucursal = async (id) => {
    //     let session = Cookies.get("AuthToken");
    //     let uri = process.env.REACT_APP_API_URL + `empresa/sucursalesEmpresa/${id}`;

    //     let config = {
    //         headers: {
    //             'Content-Type': 'multipart/form-data',
    //             'Authorization': `Bearer ${session}`,
    //         }
    //     };

    //     console.log(id, 'e')

    //     Swal.fire({
    //         title: "¿Estás seguro de borrar esta sucursal?",
    //         text: "¡Esta acción no se puede deshacer!",
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#d33",
    //         cancelButtonColor: "#3085d6",
    //         confirmButtonText: "Sí, eliminar",
    //         cancelButtonText: "Cancelar",
    //     }).then(async (result) => {
    //         if (result.isConfirmed) {
    //             try {
    //                 await axios.delete(uri, config);
    //                 setSucursales((prevSucursales) => prevSucursales.filter((sucursal) => sucursal.id !== id));
    //                 Swal.fire("¡Eliminado!", "La sucursal ha sido eliminada.", "success");
    //             } catch (error) {
    //                 console.error("Error al eliminar sucursal", error);
    //                 Swal.fire("Error", "No se pudo eliminar la sucursal.", "error");
    //             }
    //         }
    //     });
    // };

    const searcher = (e) => {
        setSearch(e.target.value);
    }

    // let result = colaboradores.filter((colaborador) => {
    //     return colaborador.nombre.toLowerCase().includes(search.toLowerCase());
    // });

    return (
        <>
            <div className="w-auto h-full py-10 px-3">
				<div className='flex flex-col justify-center w-auto h-auto items-center text-lg'>
					<div className="flex flex-col justify-center w-full mb-5">
						<div className="flex flex-row w-full justify-start items-start p-4">
							<Link to="/Mantenimiento" className="flex justify-start">
								<button className="bg-white border-4 border-[#0E7FA0] font-medium drop-shadow-2xl shadow-2xl text-white w-full rounded-full w-[50px] h-[50px] p-[12px]"><FontAwesomeIcon icon={faArrowLeft} className='text-[#0E7FA0] text-lg' /></button>
							</Link>
							<div className="flex flex-col w-full px-3 justify-between">
								<h1 className="text-4xl font-bold text-[#0E7FA0] text-start mb-2">
                                    Colaboradores
                                </h1>
								<p className="text-base">
									Está sección es dedicada para la visualización y edición de los colaboradores de las empresas.
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className='h-full w-auto mx-6'>
					<DataTableComponent
						nameTable={"Colaboradores"}
						data={colaboradores}
						columns={columns}
						loading={loading}
						setLoading={setLoading}
						reload={getColaboradores}
						toEdit={'/EditarColaborador/'}
						toDelete={'empresa/colaboradores/destroy/'}
                        toEnable={'empresa/colaboradores/enable/'}
                        toDisable={'empresa/colaboradores/disable/'}
					/>
				</div>
			</div>
            {/* <div className="ml-28 w-auto h-full">
                <div className='flex flex-col justify-center w-full h-auto items-center text-lg'>
                    <div className='w-full'>
                        <div className="flex flex-row w-auto items-start p-4">
                            <Link to="/Mantenimiento" className="flex justify-start">
                                <button className="bg-white border-4 border-[#0E7FA0] font-medium drop-shadow-2xl shadow-2xl text-white w-full rounded-full w-[50px] h-[50px] p-[12px]"><FontAwesomeIcon icon={faArrowLeft} className='text-[#0E7FA0] text-lg' /></button>
                            </Link>
                            <div className="flex flex-col w-auto px-3 justify-between">
                                <h1 className="text-4xl font-bold text-[#063E5F] text-start">Colaboradores</h1>
                                <p className="font-normal">
                                    Está sección para la visualización y edición de los colaboradores de las empresas.
                                </p>
                            </div>
                        </div>
                        <div className='flex flex-row justify-start w-1/2 mb-4 ml-6'>
                            <input type='text' value={search} placeholder="Buscar" onChange={searcher} className='w-1/2 border-2 p-4 mx-2 text-lg rounded-lg font-normal' />
                        </div>
                        <div className='h-full w-auto ml-6 mr-6'>
                            <table className="border-2 table-auto border-collapse w-full rounded-t-2xl uppercase">
                                <thead className='bg-[#0E7FA0] text-white font-bold'>
                                    <tr>
                                        <th className='border py-2'>Nombre</th>
                                        <th className='border py-2'>DUI</th>
                                        <th className='border py-2'>Área</th>
                                        <th className='border py-2'>Sucursal</th>
                                        <th className='border py-2'>Estado</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody className="text-center">
                                    {result.map((colaborador, i) => {
                                        return (
                                            <tr key={i}>
                                                <td className='border p-1'>{colaborador.nombre}</td>
                                                <td className='border p-1'>{colaborador.dui}</td>
                                                <td className='border p-1'>{colaborador.area_trabajo}</td>
                                                <td className='border p-1'>{colaborador.id_empresa}</td>
                                                <td className='border p-1'>
                                                    {colaborador.status === 1 ? <>
                                                        <span className='text-green-600 font-bold'>Activo</span>
                                                    </> : <>
                                                        <span className='text-orange-500 font-bold'>Inactivo</span>
                                                    </>}
                                                </td>
                                                <td className='border p-1'>
                                                    <div className='flex flex-row justify-center w-auto'>
                                                        <Link to={`/EditarColaborador/${colaborador.id}`}>
                                                            <FontAwesomeIcon icon={faPenToSquare} className='p-2 text-xl h-6 w-auto rounded-full text-[#0E7FA0]' />
                                                        </Link>
                                                        <button onClick={() => enableOrDisableColaborador(colaborador.id, colaborador.status)}>
                                                            {colaborador.status === 1 ? (
                                                                <FontAwesomeIcon icon={faEyeSlash} className='p-2 text-xl h-6 w-auto rounded-full text-orange-500' />
                                                            ) : (
                                                                <FontAwesomeIcon icon={faEye} className='p-2 text-xl h-6 w-auto rounded-full text-green-600' />
                                                            )}
                                                        </button>
                                                        <button onClick={() => deleteColaborador(colaborador.id)}>
                                                            <FontAwesomeIcon icon={faTrash} className='p-2 text-xl h-6 w-auto rounded-full text-red-600' />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>   
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    )
}

export default CRUDColaboradores;